const API_KEY = 'AIzaSyD7Amzi6q3sCeCuRaipNx7dtifVztUHXEU'
const CALLBACK_NAME = 'gmapsCallback'

// Resolved once the Maps script has called our callback. Kept at module scope so
// concurrent mounts share a single script tag, and cleared again on failure so a
// later mount can retry.
let initPromise = null

export default function init (locale) {
  // If we are on the server, return a promise that never resolves or handle accordingly
  // Nuxt/SSR check
  if (process.server) { return Promise.resolve() }

  if (window.google && window.google.maps) {
    return Promise.resolve(window.google)
  }

  if (initPromise) {
    return initPromise
  }

  initPromise = new Promise((resolve, reject) => {
    window[CALLBACK_NAME] = () => {
      delete window[CALLBACK_NAME]
      resolve(window.google)
    }

    const script = document.createElement('script')
    script.async = true
    script.defer = true
    // loading=async is the documented pairing for the callback bootstrap — without
    // it the API logs "Google Maps JavaScript API has been loaded directly without
    // loading=async" on every page that shows a map.
    // libraries=marker provides AdvancedMarkerElement, the supported replacement
    // for the deprecated google.maps.Marker.
    // Use the passed locale or fallback
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=${CALLBACK_NAME}&language=${locale}&libraries=marker&loading=async`

    script.onerror = (error) => {
      // Drop the cached promise so a later mount can try again. Previously the
      // rejection was cached for the lifetime of the SPA session, so a single
      // failed load — an offline blip, a blocked request — left every subsequent
      // map on every subsequent page permanently broken.
      initPromise = null
      delete window[CALLBACK_NAME]
      script.remove()

      reject(error)
    }

    // Use document.head directly, which is more reliable than querySelector
    const head = document.head || document.getElementsByTagName('head')[0]
    if (head) {
      head.appendChild(script)
    } else {
      // Fallback to body if head is missing for some reason
      document.body.appendChild(script)
    }
  })

  return initPromise
}
